import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { ExternalOts, UpdateExternalOts } from "./external-ots.interface";

export const externalOtsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExternalOts: builder.query<APIResponse<ExternalOts[]>, void>({
      query: () => ({ url: "auth/works-orders/external-ots" }),
      providesTags: ["ExternalOts"],
    }),

    searchExternalOts: builder.query<APIResponse<ExternalOts[]>, string>({
      query: (search) => ({
        url: "auth/works-orders/external-ots/search",
        params: { search },
      }),
      providesTags: ["ExternalOts"],
    }),

    getExternalOtsById: builder.query<APIResponse<ExternalOts>, number>({
      query: (id) => ({ url: `auth/works-orders/external-ots/${id}` }),
      providesTags: (_result, _error, id) => [{ type: "ExternalOts", id }],
    }),

    updateExternalOts: builder.mutation<APIResponse<ExternalOts>, { id: number; changes: UpdateExternalOts }>({
      query: ({ id, changes }) => ({
        url: `auth/works-orders/external-ots/${id}`,
        method: "PATCH",
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "ExternalOts", id }, "ExternalOts"],
    }),
  }),
});

export const {
  useGetExternalOtsQuery,
  useLazyGetExternalOtsQuery,
  useSearchExternalOtsQuery,
  useLazySearchExternalOtsQuery,
  useGetExternalOtsByIdQuery,
  useLazyGetExternalOtsByIdQuery,
  useUpdateExternalOtsMutation,
} = externalOtsApi;
